import React from "react";
import "./Projects.css";
import { motion } from "framer-motion";
import { FaGithub, FaExternalLinkAlt } from "react-icons/fa";
import { portfolioData } from "../../data/portfolioData";


const Projects = () => {
  const projectsData =portfolioData.projects

  return (
    <section className="projects-section" id="projects">
      <div className="projects-container">
        
        {/* Section Title Header */}
        <motion.div 
          className="projects-header"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <span className="projects-subtitle">MY WORK</span>
          <h2 className="projects-title">Projects</h2>
          <p className="projects-description">
            Some of my engineering work built across different technical stacks.
          </p>
        </motion.div>

        {/* 3-Column Responsive Grid Layout */}
        <div className="projects-grid">
          {projectsData.map((project, index) => (
            <motion.div 
              key={project.id}
              className="project-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.08 }}
            >
              {/* Media Image Header (Simplified Structure) */}
              <div className="card-media-box">
                <div className="card-media-overlay"></div>
                <img src={project.image} alt={project.title} className="card-img" />
              </div>

              {/* Detailed Card Project Information */}
              <div className="card-info-box">
                <h3 className="card-project-title">
                  <a href={project.liveLink} target="_blank" rel="noreferrer" className="title-link">
                    {project.title}
                  </a>
                </h3>
                <p className="card-project-desc">{project.description}</p>
                
                {/* Tech Stack Wrapper Box */}
                <div className="card-tech-footer">
                  <span className="tech-stack-label">Tech Stack:</span>
                  <p className="tech-stack-text">{project.stack}</p>
                </div>

                {/* Bottom Source & Live Demo Action Buttons */}
                <div className="card-action-links">
                  <a href={project.githubLink} target="_blank" rel="noreferrer" className="card-link-btn btn-outline">
                    <FaGithub /> Code
                  </a>
                  <a href={project.liveLink} target="_blank" rel="noreferrer" className="card-link-btn btn-solid">
                    Demo <FaExternalLinkAlt className="mini-icon" />
                  </a>
                </div>
              </div>

            </motion.div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Projects;